import { setApiDomain } from './setApiDomain';

let configuration = null;
function getConfigurationSourceCode() {
	configuration = JSON.parse(localStorage.getItem('xs_configuration'));
    setApiDomain(configuration);
    
    if (configuration && window.appConfig && window.appConfig.SHOP_MODE) {
        // deactivate all the online functionalities by default
        configuration.bwe = false;
		configuration.lme = false;
        configuration.tme = false;
        configuration.cre = false;
        configuration.bse = false;
        configuration.lwe = false;
        configuration.tfs = true;
        configuration.anbe = false;
        configuration.mybbp = false;
        configuration.frbe = false;
		configuration.bfs = {
			maxw :0,
			fms: []
		};
    }
	if(window.appConfig?.TERMINAL_AGENCY) {
		//configuration.cwe = false;
	}
	if (window.appConfig?.XSHOP_TERMINAL) {
		configuration.bco = ['multibets', 'systembets'];
	}

    if (window.seoConfig && configuration) {
        configuration.seo = window.seoConfig;
    }

	if (configuration && configuration.gdprscc) {
		try {
			configuration.gdprscc = JSON.parse(configuration.gdprscc);
		}catch(err) {
			console.error(err);
		}
	}

    if (configuration) {
		// override function, in order to return forever the calculated configuration object 
    	getConfiguration = () => configuration;
	}
	else{
		return configuration;
	}
	
	return getConfiguration();
}

export let getConfiguration = function() {
    return getConfigurationSourceCode();
}

export function resetConfiguration() {
	configuration = null;
	// restoring the original function, in order to be sure that the function will calculate the new configuration with the original source code
	getConfiguration = () => {
		return getConfigurationSourceCode();
	}
}
